export default (value) => {
  return value + 'kg'
}



// WEBPACK FOOTER //
// ./src/filters/tokilograma.js